import React from "react";

const FB = ({ checkboxState, handleCheckboxChange }) => {
  return (
    <div>
      <div className="edit-profile-interest-option-div">
        <div className="edit-profile-icon-wrapper">
          <div className="tabs-nav-icon w-embed">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 82 78"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_16_288)">
                <path
                  d="M25.495 47.0291C27.5589 45.9954 29.2929 44.7774 30.8031 42.9782C31.452 42.2072 32.2239 41.9613 32.9566 42.0675C34.1089 40.1342 34.9814 38.0054 35.6471 36.0778C36.598 33.3344 36.928 30.5798 37.5488 27.7637C37.8509 26.3781 38.5165 25.1712 38.8857 23.8246C39.2716 22.4278 38.9472 21.0868 38.9248 19.6564C38.9192 19.1033 39.0423 18.6339 39.2604 18.2484C36.4525 17.1924 33.6558 16.4772 30.6801 15.7006C26.8877 14.7116 23.1345 13.8009 19.1967 13.717C17.9606 13.6947 17.1495 13.0186 16.7636 12.147C13.9948 11.5044 11.1757 10.996 8.34543 10.9178C8.2895 10.9178 8.23916 10.9122 8.18322 10.9066C7.4337 18.2819 4.53629 25.4226 4.86071 32.8874C5.297 42.9223 15.3149 45.3752 23.0562 48.5824C23.733 47.9342 24.5944 47.4705 25.495 47.0179V47.0291Z"
                  fill="#E2B760"
                />
                <path
                  d="M72.1947 54.8067C74.5887 53.2087 77.4189 51.9795 78.9516 49.4317C80.4953 46.867 81.5301 43.5202 81.5078 40.5309C81.4854 37.0053 81.0938 33.435 80.7023 29.9372C80.3723 26.9815 79.4997 24.0984 79.3039 21.1315C78.9348 21.1427 78.5712 21.1595 78.2076 21.1874C74.516 21.5115 70.8131 21.6903 67.1102 21.9193C63.1277 22.1652 59.2514 22.5842 55.3192 23.2324C52.2372 23.7408 49.1385 23.5173 46.0677 23.7352C46.3585 24.1319 46.5599 24.6236 46.6046 25.2159C47.2535 33.15 47.4548 43.7213 54.111 49.2305C57.4 51.9516 61.651 52.9294 65.6615 54.0692C67.5633 54.6112 69.4483 55.1978 71.3556 55.6839C71.5626 55.3487 71.8367 55.047 72.1891 54.8067H72.1947Z"
                  fill="#E2B760"
                />
                <path
                  d="M63.5975 57.8016C54.2285 57.8016 46.2019 50.6553 45.3069 41.1567L43.7128 24.2437C43.6681 23.7799 44.0093 23.3721 44.4679 23.3329L79.4046 20.0531C79.6284 20.0364 79.8465 20.0978 80.0199 20.2431C80.1933 20.3828 80.2996 20.5895 80.3219 20.8074L81.9161 37.7205C82.867 47.8001 75.4277 56.7735 65.3315 57.7233C64.7498 57.7792 64.1681 57.8072 63.5975 57.8072V57.8016ZM45.4636 24.9198L46.9794 40.9947C47.8408 50.158 56.0072 56.9076 65.1749 56.0471C74.3481 55.1867 81.105 47.0291 80.2436 37.8713L78.7278 21.7964L45.4636 24.9198Z"
                  fill="#000"
                />
                <path
                  d="M67.1046 77.3798C66.6795 77.3798 66.3104 77.0557 66.2712 76.6199L64.4198 56.9635C64.375 56.4997 64.7162 56.0918 65.1749 56.0527C65.6391 56.0136 66.0475 56.3489 66.0866 56.807L67.9381 76.4635C67.9828 76.9272 67.6416 77.3351 67.1829 77.3742C67.155 77.3742 67.127 77.3742 67.1046 77.3742V77.3798Z"
                  fill="#000"
                />
                <path
                  d="M60.4932 78C60.0681 78 59.6989 77.6759 59.6597 77.2401C59.615 76.7763 59.9562 76.3685 60.4149 76.3293L73.6322 75.0889C74.0964 75.0498 74.5048 75.3851 74.5439 75.8432C74.5887 76.307 74.2475 76.7149 73.7888 76.754L60.5715 77.9944C60.5715 77.9944 60.5155 77.9944 60.4932 77.9944V78Z"
                  fill="#000"
                />
                <path
                  d="M68.5421 39.4191L51.1409 39.3185C50.6767 39.3185 50.3019 38.9385 50.3075 38.4748C50.3075 38.011 50.6879 37.6423 51.1465 37.6423L68.5477 37.7428C69.012 37.7428 69.3868 38.1228 69.3812 38.5865C69.3812 39.0503 69.0008 39.4191 68.5421 39.4191Z"
                  fill="#000"
                />
                <path
                  d="M18.3857 49.1746C16.9761 49.1746 15.5442 49.0126 14.1123 48.6718C4.25661 46.3139 -1.85143 36.3851 0.503409 26.5401L4.45239 10.0182C4.50273 9.80029 4.64256 9.6159 4.82715 9.49857C5.01732 9.38123 5.24666 9.34771 5.45921 9.398L39.5905 17.5444C40.0435 17.6506 40.3176 18.1032 40.2113 18.5557L36.2623 35.0777C34.2487 43.4979 26.6919 49.1746 18.3801 49.1746H18.3857ZM5.8955 11.2251L2.14229 26.9312C-1.46031e-06 35.8766 5.54311 44.9003 14.5038 47.0347C23.4645 49.1746 32.4924 43.632 34.6347 34.6809L38.3879 18.9748L5.8955 11.2251Z"
                  fill="#000"
                />
                <path
                  d="M9.71581 67.8924C9.64869 67.8924 9.58716 67.8868 9.52004 67.8701C9.06697 67.7639 8.79289 67.3113 8.89917 66.8587L13.4914 47.6549C13.5977 47.2023 14.0507 46.9285 14.5038 47.0347C14.9569 47.1408 15.231 47.5934 15.1247 48.046L10.5325 67.2499C10.443 67.6354 10.0962 67.8924 9.71581 67.8924Z"
                  fill="#000"
                />
                <path
                  d="M16.1762 69.4345C16.1091 69.4345 16.0476 69.4289 15.9805 69.4122L3.07079 66.3279C2.61772 66.2218 2.34364 65.7692 2.44992 65.3166C2.55619 64.864 3.00926 64.5903 3.46233 64.6964L16.372 67.7807C16.8251 67.8868 17.0992 68.3394 16.9929 68.792C16.8978 69.1775 16.5566 69.4345 16.1762 69.4345Z"
                  fill="#000"
                />
                <path
                  d="M24.091 29.669L6.68978 29.5685C6.22552 29.5685 5.85076 29.1885 5.85635 28.7248C5.85635 28.261 6.23671 27.8923 6.69537 27.8923L24.0966 27.9928C24.5609 27.9928 24.9356 28.3728 24.93 28.8365C24.93 29.3003 24.5497 29.669 24.091 29.669Z"
                  fill="#000"
                />
                <path
                  d="M44.1603 9.56003C44.1043 9.56003 44.0428 9.55444 43.9813 9.54327C43.5282 9.44828 43.2374 9.00129 43.338 8.54871L45.0329 0.664903C45.128 0.212324 45.5754 -0.0726332 46.0285 0.0223525C46.4816 0.117338 46.7724 0.56433 46.6717 1.01691L44.9769 8.90072C44.893 9.29184 44.5462 9.56562 44.1603 9.56562V9.56003Z"
                  fill="#000"
                />
                <path
                  d="M36.6259 10.9401C36.3518 10.9401 36.0834 10.806 35.9211 10.5546L31.5415 3.79384C31.4688 3.68209 31.424 3.55358 31.4128 3.41948C31.3681 2.96132 31.7093 2.54785 32.1679 2.50315C32.5203 2.47522 32.828 2.64842 32.9846 2.93897L37.3307 9.64943C37.5824 10.0405 37.4705 10.5546 37.0846 10.806C36.9447 10.8954 36.7825 10.9401 36.6315 10.9401H36.6259Z"
                  fill="#000"
                />
                <path
                  d="M50.4697 13.8958C50.1956 13.8958 49.9272 13.7617 49.7649 13.5103C49.5132 13.1192 49.6251 12.6052 50.0111 12.3537L56.7791 7.97879C56.891 7.90616 57.0252 7.86146 57.1595 7.85028C57.6182 7.80558 58.0321 8.14642 58.0712 8.61017C58.1048 8.95659 57.9202 9.26948 57.6349 9.42593L50.9172 13.7673C50.7774 13.8567 50.6151 13.9014 50.4641 13.9014L50.4697 13.8958Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_16_288">
                  <rect width={82} height={78} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label className="w-checkbox ms-pill-item">
          <input
            type="checkbox"
            name="checkbox-3"
            id="checkbox-3w"
            data-name="Checkbox 3"
            className="w-checkbox-input ms-pill-checkbox"
            checked={checkboxState.fAndB}
            onChange={handleCheckboxChange("fAndB")}
          />
          <span
            className="ms-pill-label has-icon w-form-label"
            htmlFor="checkbox-3"
          >
            F&amp;B
          </span>
          <div className="ms-pill-icon w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
            </svg>
          </div>
        </label>
      </div>
    </div>
  );
};

export default FB;
